import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5c10a0d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cf" }
const _hoisted_2 = { class: "cf__elm" }
const _hoisted_3 = { class: "cf__elm-label" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cf__elm-label" }, "Введите код подтверждения", -1))
const _hoisted_5 = { class: "cf__elm-code" }
const _hoisted_6 = { class: "cf__elm-code-input" }
const _hoisted_7 = { class: "cf__elm-code-input" }
const _hoisted_8 = { class: "cf__elm-code-input" }
const _hoisted_9 = { class: "cf__elm-code-input" }
const _hoisted_10 = { class: "cf__elm-code-input" }
const _hoisted_11 = {
  key: 1,
  class: "cf__elm-error"
}
const _hoisted_12 = {
  key: 2,
  class: "cf__elm-error"
}
const _hoisted_13 = {
  key: 3,
  class: "cf__elm-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, " Для номера " + _toDisplayString(_ctx.formatPhoneNumber(_ctx.phoneNumber.phone)) + " отправлен код. ", 1),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            id: "1",
            ref: "d1",
            onKeyup: [
              _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDigit && _ctx.onDigit(...args))),
              _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onClickCheckCode && _ctx.onClickCheckCode(...args)), ["enter"]))
            ],
            type: "number",
            class: "cf__elm-code-input-num"
          }, null, 544)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("input", {
            id: "2",
            ref: "d2",
            onKeyup: [
              _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDigit && _ctx.onDigit(...args))),
              _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onClickCheckCode && _ctx.onClickCheckCode(...args)), ["enter"]))
            ],
            type: "number",
            class: "cf__elm-code-input-num"
          }, null, 544)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("input", {
            id: "3",
            ref: "d3",
            onKeyup: [
              _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDigit && _ctx.onDigit(...args))),
              _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onClickCheckCode && _ctx.onClickCheckCode(...args)), ["enter"]))
            ],
            type: "number",
            class: "cf__elm-code-input-num"
          }, null, 544)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("input", {
            id: "4",
            ref: "d4",
            onKeyup: [
              _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onDigit && _ctx.onDigit(...args))),
              _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onClickCheckCode && _ctx.onClickCheckCode(...args)), ["enter"]))
            ],
            type: "number",
            class: "cf__elm-code-input-num"
          }, null, 544)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("input", {
            id: "5",
            ref: "d5",
            onKeyup: [
              _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onDigit && _ctx.onDigit(...args))),
              _cache[9] || (_cache[9] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onClickCheckCode && _ctx.onClickCheckCode(...args)), ["enter"]))
            ],
            type: "number",
            class: "cf__elm-code-input-num"
          }, null, 544)
        ])
      ]),
      _createVNode(_component_UiButton, {
        class: "cf__elm-btn",
        onClick: _ctx.onClickCheckCode,
        label: "Отправить",
        "background-color": 
					_ctx.isButtonDisable
						? 'rgb(244, 246, 250)'
						: `var(--theme-color)`
				,
        "border-color": 
					_ctx.isButtonDisable
						? 'rgb(244, 246, 250)'
						: `var(--theme-color)`
				,
        color: "rgb(255, 255, 255)",
        "font-weight": "600",
        "font-size": "16px"
      }, null, 8, ["onClick", "background-color", "border-color"]),
      (_ctx.isExpired)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cf__elm-send-code",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resendConfirmCode && _ctx.resendConfirmCode(...args)))
          }, " Повторно отправить код "))
        : _createCommentVNode("", true),
      (_ctx.attemptsCount !== 0 && _ctx.attemptsCount < 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Неверно введен проверочный код. Осталось " + _toDisplayString(3 - _ctx.attemptsCount) + " попытки. ", 1))
        : _createCommentVNode("", true),
      (_ctx.attemptsCount > 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, " В течение 5 мин. Ваш номер телефона заблокирован. "))
        : _createCommentVNode("", true),
      (_ctx.isExpired)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Проверочный код недействителен "))
        : _createCommentVNode("", true)
    ])
  ]))
}